import { css } from 'styled-components'

export default css`
  border-left: 4px solid #404040;
  border-right: 4px solid #d8d8d8;
  padding-left: 40px !important;
  padding-right: 40px !important;
`
